import { render, staticRenderFns } from "./role_add_dialog.vue?vue&type=template&id=2bc8be73&"
import script from "./role_add_dialog.vue?vue&type=script&lang=js&"
export * from "./role_add_dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports